import React from "react";
import { observer } from "mobx-react-lite";
import CompetitionBilling from "../../Games/CompetitionBilling";

const CompetitionBillingTrainer = () => {
  return <CompetitionBilling role="TRN" />;
};

export default observer(CompetitionBillingTrainer);